<template>
  <div id="TelebarqGM">
    <div class="mainText orange">• telebarq •</div>
    <div class="tele_outline">
      <div v-for="(value, name) in Teles" :key="name" class="table" :class="[name.length > 19 ? 'double' : '']">
        <div class="name">{{ name }}</div>
        <!-- <div class="recip">recip</div> -->
        <div class="OUT orange" @click="prepareSend(name)" v-if="Teles_sent[name]">
          OUT
        </div>
        <div class="OUT pointer" @click="prepareSend(name)" v-else>send</div>
      </div>
    </div>
    <div v-if="currentTele" id="Popup">
      <div class="close pointer" @click="close()">x</div>
      <div>Select Recipient(s) - {{ currentTele }}</div>
      <!-- <div>Selected recipients: {{ recipients_text }}</div> -->
      <div>Add recipients:</div>
      <div class="recipientsShell">
        <div @click="selectRecipient('all')" class="recipients all pointer">
          All
        </div>
        <template v-for="(P, i) in players" :key="i">
          <div @click="selectRecipient(i)" class="recipients pointer" :class="recipients[i] ? 'selected' : ''">
            {{ P.name }}
          </div>
        </template>
      </div>

      <button @click="send()" class="submitButton">submit</button>
    </div>
  </div>
</template>

<script>
import Teles from "../../telebarq.json";

export default {
  name: "TelebarqGM",
  emits: ["send"],
  props: {
    players: {
      type: Object,
      default: () => { },
    },
  },
  watch: {
    players: function (newVal) {
      // watch it
      // console.log(newVal);
      for (const P in newVal) {
        // console.log(P);
        for (const T of newVal[P].telebarqs) {
          // console.log(T);
          if (!this.Teles_sent[T]) this.Teles_sent[T] = true;
        }
      }
    },
  },
  data() {
    return {
      Teles: Teles,
      Teles_sent: {},
      currentTele: "",
      recipients: {},
      selected_all: false,
    };
    //  "A_1": {
    //   "text": "blabla bla bal",
    //   "special": "non"
    // },
    // "A_2": {
    //   "text": "blabla bla bal",
    //   "special": "canvas",
    //   "x": 10,
    //   "y": 10,
    //   "width": 50,
    //   "height": 100
    // },
  },

  methods: {
    send() {
      try {
        this.Teles_sent[this.currentTele] = true;
      } catch (e) {
        console.log("telebarq not found");
      }
      this.$emit("send", this.currentTele, this.recipients);
      this.close();
    },
    close() {
      this.currentTele = "";
      this.recipients = {};
    },
    prepareSend(name) {
      this.currentTele = name;
    },
    selectRecipient(userId) {
      if (userId == "all") {
        this.selected_all = !this.selected_all;
        for (const P in this.players) {
          // console.log(P);
          this.recipients[P] = this.selected_all;
        }
        // console.log(this.recipients);
        return true;
      }
      if (this.recipients[userId]) {
        //remove player
        this.recipients[userId] = false;
      } else {
        this.recipients[userId] = true;
      }
    },
  },
};
</script>

<style scoped>
.double {
  height: 50px !important;
}

.mainText {
  font-size: 25px;
  text-align: center;
}

#TelebarqGM {
  position: relative;
  width: calc(100% - 29% - 32px);
}

.submitButton {
  height: 42px;
  border: 3px solid #214a7c;
  background: white;
  color: #214a7c;
  width: 100%;
  font-size: 19px;
}

.submitButton:hover {
  cursor: pointer;
  border: 3px solid white;
  background: #214a7c;
  color: white;
}

.recipientsShell {
  display: flex;
  flex-wrap: wrap;
}

.recipients {
  margin: 4px;
  border: 1px solid black;
  padding: 2px;
  text-align: center;
  flex: 1 1 30%;
}

.close {
  position: absolute;
  right: 0px;
  top: 0px;
  color: var(--barq-orange);
  border-left: 2px solid var(--barq-orange);
  border-bottom: 2px solid var(--barq-orange);
  height: 25px;
  width: 25px;
  line-height: 22px;
  text-align: center;
  font-size: 24px;
}

.close:hover {
  background: var(--barq-orange);
  color: white;
}

.all {
  flex-basis: 100%;
}

.selected {
  background: #28f528;
  border: 1px solid #28f528;
}

#Popup {
  border: 2px solid var(--barq-orange);
  position: absolute;
  top: 20%;
  background: white;
  padding: 10px;
  padding-right: 20px;
  left: calc(50% - 150px);
  width: 300px;
}

.orange {
  color: var(--barq-orange);
}

.tele_outline {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  height: 610px;
}

.OUT {
  border-left: 2px solid var(--barq-orange);
  padding: 0 10px;
}

.OUT:hover {
  background: var(--barq-orange);
  color: white;
}

.table {
  display: flex;
  justify-content: center;
  padding: 5px 5px;
  /* width: 200px; */
  /* border-top: 1px solid black;
  border-right: 1px solid black; */
  box-shadow: 1px 0 0 0 #000000, 0 1px 0 0 #000000, 1px 1px 0 0 #000000,
    /* Just to fix the corner */
    1px 0 0 0 #000000 inset,
    0 1px 0 0 #000000 inset;
  height: 20px;
}

.name {
  width: 150px;
}
</style>
